import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=11a7c072&scoped=true&"
import script from "./scene.vue?vue&type=script&lang=js&"
export * from "./scene.vue?vue&type=script&lang=js&"
import style0 from "./scene.vue?vue&type=style&index=0&id=11a7c072&scoped=true&lang=css&"
import style1 from "./scene.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a7c072",
  null
  
)

export default component.exports